import { useAuth } from '../auth/AuthProvider';

/**
 * Whether the active tenant is an ORGANISATION, which holds no operational data.
 *
 * Exported so a page can also correct its own empty-state wording — the notice
 * explains the absence, but a table still saying "try adjusting your filters"
 * underneath it blames the reader for a search they did not make.
 */
export function useInOrganisation(): boolean {
  const { tenantId, tenantChoices, assumedTenant } = useAuth();
  /*
   * ⚠️ The ASSUMED tenant first, because it is not in `tenantChoices` at all —
   * a platform administrator holds no membership, so every screen that read
   * `isParent` from the choices answered FALSE for them. The consequence was
   * silent and exactly backwards: the one person most likely to be standing in
   * an organisation wondering why it is empty was the one person the
   * explanation never reached.
   */
  if (assumedTenant && assumedTenant.id === tenantId) return assumedTenant.isParent;
  return tenantChoices.find((c) => c.tenantId === tenantId)?.isParent === true;
}
